import React, {useState} from 'react';
import 'swiper/swiper-bundle.css';
import { Link } from 'react-router-dom';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Pagination, Scrollbar, A11y, EffectFade, Autoplay} from 'swiper';
import '../assets/css/home.css';
import { FaDatabase, FaGlobeAfrica, FaLaptopCode, FaBars, FaArrowRight } from 'react-icons/fa';


SwiperCore.use([Pagination, Scrollbar, A11y, EffectFade, Autoplay]);


const Home = ()=>{
    const [open, setOpen] = useState(false);
        return(
            <div className="">
                    <nav>
                         <div className="logo">fm</div>
                        <ul className="nav-links" style={{transform: open? "translateX(0px)": ""}}>
                        <li><Link className="nav-item"  to="/">About</Link></li>
                        <li>< a href="#service"className="nav-item" >Services</a></li>
                        <li><a className="nav-item" href="#resume" >Resume</a></li>
                        <li><a className="nav-item" href="#skills">Skills</a></li>
                        <li><a className="nav-item" href="#mentor">Mentors</a></li>
                        <li><Link className="nav-item" to="/projects">Projects</Link></li>
                        <li><Link className="nav-item" to="/blog">Blog</Link></li>
                        <li><Link className="nav-item" to="/contact">Contact</Link></li>
                        </ul>
                    <FaBars onClick={() => setOpen(!open)} className="fa-bars" color="#5cb85c"/>
                    </nav>
                <div className="swiper-container">
                    <div className="swiper-wrapper">
                        <Swiper
                            fadeEffect={{crossFade:true}}
                            slidesPerView={1}
                            speed ={2000}
                            effect={"fade"}
                            autoplay={{
                                delay: 8000,
                                disableOnInteraction: true}}
                            pagination={{ clickable: true }}
                            //onSwiper={(swiper) => console.log(swiper)}
                            //onSlideChange={() => console.log('slide change')}
                        >
                            <SwiperSlide className="swiper-one">
                                <div className="swiper-slide">
                                    <div className="row" id="banner">
                                        <div className="col-sm-6" id="columntext">
                                            <p className="text-muted lead mt-0" id="title1">Hello!</p>
                                            <h1 className='title1' id="title1">I am Muchembi Faith, a Geographer
                                                and<br />Software Developer
                                            </h1>
                                            <p className="text-muted lead mt-0" id="about-description">I am confident and hardworking, a self –starter with passion for
                                            excellence and willingness to learn from others, I have a strong sense of responsibility; Am a team player and a quick learner.</p>
                                            <p className='btnsuccess'>
                                                <button className='btn btn-success'><a href="#projects" id="projects-button">MY WORKS</a></button>
                                            </p>
                                        </div>
                                        <div className="col-sm-6">
                                            <img src="/images/muchembi.png" alt="Faith" id="faiImg" />
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="swiper-two">
                                <div className="swiper-slide">
                                    <div className="row" id="banner">
                                        <div className="col-sm-6" id="columntext1">
                                            <h1 className='title1'>I am based in Nairobi, Kenya</h1>
                                            <p className="text-muted lead mt-0" id="about-description">I enjoy collecting spatial data, processing and analysing it to provide solutions to the
                                            challanges we face in space, or help in decision making.</p>
                                            <p className='btnsuccess'>
                                                <button className='btn btn-success'><a href="#projects" id="projects-button">MY WORKS</a></button>
                                            </p>
                                        </div>
                                        <div className="col-sm-6">
                                           
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
                <section className="the-services" id="service">
                    <div id="the-services">
                        <h1 id="big">SERVICES</h1>
                        <p className="text-muted lead mt-0">Some of the technical services I offer</p>
                    </div>
                    <div className="container-fluid-3">
                        <div className="row">
                            <div id='col-sm' className="col-sm">
                                <div id="first">
                                    <FaGlobeAfrica size="5em" color="white" padding-button="10px"/>
                                    <h4>GIS AND REMOTE SENSING</h4>
                                </div>
                                <div id="designs">
                                    <p className="text-light lead mt-0">GIS is Technology that organizes information into all types of layers that can be visualized, analyzed and combined
                                    to help us understand almost everything about our world.</p>
                                    <p className="text-light lead mt-0">Remote Sensing is a GIS data source, I do spatial data collection, Data visualization and mapping as well us analysis
                                    and modelling. </p>
                                </div>
                            </div>
                            <div id='col-sm' className="col-sm">
                                <div id="second">
                                    <FaDatabase size="5em" color="white" padding-button="100px"/>
                                    <h4>DATABASE MANAGEMENT</h4>
                                </div>
                                <div id="services">
                                    <p className="text-light lead mt-0">Involves creating, using and maintaining Databases using DBMs. and DBMs are basically a software
                                    package that allows user to setup, use and maintain a database.</p>
                                    <p className="text-light lead mt-0">I work with Postgresql</p>
                                </div>
                            </div>
                            <div id='col-sm' className="col-sm">
                                <div id="third">
                                    <FaLaptopCode size="5em" color="white" padding-button="10px"/>
                                    <h4 id="textbox">WEB DEVELOPMENT</h4>
                                </div>
                                <div id="managment">
                                    <p className="text-light lead mt-0">This is the building and maintainance of websites.</p>
                                    <p className="text-light lead mt-0">I am a full stack Web Developer. I use Javascript and Python Languages, for frameworks I use React, Expess js and Node js and Django,
                                    the HTML and SASS and Bootstrap CSS frameworks.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="resume">
                    <div className='container-fluid-2'>
                        <div id="the-resume">
                            <h1 id="big">RESUME</h1>
                            <p className="text-muted lead mt-0"> Get a copy of my professional and educational background details  by clicking on the download here button</p>
                        </div>
                        <div id='downloaddiv'>
                            <button id='downloadResume' className='btn btn-success'><a href='https://drive.google.com/file/d/1Bgk2KHgTN4tG4DNNAK52-sfzP0yaku97/view?usp=sharing'>Download Here</a></button>
                        </div>
                    </div>
                </section>                               
                <section id='skills'>
                    <div className='container-fluid-4' id="4">
                        <div id='theSkills'>
                            <h1 id="big">SKILLS</h1>
                            <p className="text-muted lead mt-0">My degree gives me a background in Geospatial Technology
                            on the other hand I am a Tech enthusiast thus a self taught Programmer<br />
                            that intergrates both disciplines to provide Geospatial solutions</p>
                        </div>
                        <div className='allSkills'>
                            <div className="row">
                                <div className="col-sm">
                                    <img id="skillsIcon" src="images/skills/javascript.ico" />
                                </div>
                                <div className="col-sm">
                                    <img id="skillsIcon" src="images/skills/React.ico" />
                                </div>
                                <div className="col-sm">
                                    <img id="skillsIcon" src="images/skills/Python.ico" />
                                </div>
                                <div className="col-sm">
                                    <img id="skillsIcon" src="images/skills/Django.ico" />
                                </div>
                                <div className="col-sm">
                                    <img id="skillsIcon" src="images/skills/Sql.ico"/>
                                </div>
                                <div className="col-sm">
                                    <img id="skillsIcon" src="images/skills/Bootstrap.ico" />
                                </div>
                                <div className="col-sm">
                                    <img id="skillsIcon" src="images/skills/World Map.ico" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id='mentor'>
                    <div className='mentors-row'>
                        <div id='mentors-header'>
                            <h1 id="big">MENTORS</h1>
                            <p className="text-muted lead mt-0" >These are some of the people I look upto professionally, they advice, motivate and frequently check my career progress</p>
                        </div>
                        <div id='mentors' className="row">
                            <div className="col-sm">
                                <img src="images/mentors/1.jfif" alt="" id='img-mentors'/>
                                    <h6>Brian Pondi</h6>
                                    <p className="text-muted lead mt-0">GIS Engineer<br/>Computational Geographer</p>
                                    <div className='mentors-icons'>
                                        <li id="icon1"><a href="https://www.linkedin.com/in/brian-pondi/" className="fa fa-linkedin"></a></li>
                                        <li id="icon2"><a href="https://web.facebook.com/brianpondi.geogeek" className="fa fa-facebook"></a></li>
                                        <li id="icon3"><a href="https://twitter.com/PondiB" className="fa fa-twitter"></a></li>
                                    </div>
                            </div>
                            <div className="col-sm">
                                <img src="images/mentors/2" alt="" id='img-mentors'/>
                                    <h6>Vivianne Meta</h6>
                                    <p className="text-muted lead mt-0">Geomatics Lead <br/> LocateIT Limited</p>
                                    <div className='mentors-icons'>
                                        <li id="icon1"><a href="https://www.linkedin.com/in/vivyann-meta-48749746/" className="fa fa-linkedin"></a></li>
                                        <li id="icon2"><a href="https://web.facebook.com/vivyann.meta" className="fa fa-facebook"></a></li>
                                        <li id="icon3"><a href="https://twitter.com/viviannemeta" className="fa fa-twitter"></a></li>
                                    </div>
                            </div>
                            <div className="col-sm">
                                <img src="images/mentors/3" alt="" id='img-mentors'/>
                                    <h6>Joel Tanui</h6>
                                    <p className="text-muted lead mt-0">VAS Product Developer<br/>Safaricom PLC</p>
                                    <div className='mentors-icons'>
                                        <li id="icon1"><a href="https://www.linkedin.com/in/joel-tanui-1b438158/" className="fa fa-linkedin"></a></li>
                                        <li id="icon2"><a href="https://web.facebook.com/shwedykips" className="fa fa-facebook"></a></li>
                                        <li id="icon3"><a href="" className="fa fa-twitter"></a></li>
                                    </div>
                            </div>
                        </div>
                    </div>
            </section> 
            <section className="bottom">
                <div className="bt-container">
                    <div className="green-shadow">
                        <h2 id="h1-bt">Get in touch</h2>
                        <div className='row' id="row-bt">
                            <div className="col-sm" id="bottom_buttons">
                                <button type="button" className="btn btn-success btn-lg">
                                    <Link className="bt_link" to="/contact">Reach out to me today</Link></button>
                                <div id="gif">
                                    <img src="./images/gif/giphy.gif" width="150" height="150"/>
                                </div>
                            </div>
                            <div className="col-sm" id="bottom_buttons">
                                <button type="button" className="btn btn-success btn-lg">Lets build awesome projects together</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="footer-section">
                    <div className='footer-row'>
                        <div className="row">
                            <div className="col-sm" id="footer-col-sm">
                                <h4>My main goal</h4>
                                <li><a className="">
                                    My main goal is to Intergrate <br /> existing GIS capabilities to <br />applications and solutions in<br /> various companies</a>
                                </li>
                            </div>
                            <div className="col-sm" id="footer-col-sm">
                                <h4>Links</h4>
                                <ul className="list-unstyled">
                                    <li> <FaArrowRight /><a href="#about" className="">About</a></li>
                                    <li> <FaArrowRight /><a href="#resume" className="">Resume</a></li>
                                    <li> <FaArrowRight /><a href="#service" className="">Services</a></li>
                                    <li> <FaArrowRight /><a href="#skills" className="">Skills</a></li>
                                    <li> <FaArrowRight /><a href="#projects" className="">Projects</a></li>
                                    <li> <FaArrowRight /><a href="#mentor" className="">Mentors</a></li>
                                    <li> <FaArrowRight /><a href="#contacts" className="">Contacts</a></li>
                                    <li> <FaArrowRight /><a href="#blog" className="">Blog</a></li>
                                </ul>
                            </div>
                            <div className="col-sm" id="footer-col-sm">
                                <h4 className="">Skills</h4>
                                <ul className="list-unstyled">
                                    <li><FaArrowRight /><a href="#" className="">ReactJS</a></li>
                                    <li><FaArrowRight /><a href="#" className="">NodeJS</a></li>
                                    <li><FaArrowRight /><a href="#" className="">Django</a></li>
                                    <li><FaArrowRight /><a href="#" className="">Web Development</a></li>
                                    <li><FaArrowRight /><a href="#" className="">GIS analysis</a></li>
                                    <li><FaArrowRight /><a href="#" className="">Python</a></li>
                                    <li><FaArrowRight /><a href="#" className="">Remote Sensing</a></li>
                                    <li><FaArrowRight /><a href="#" className="">Postgresql</a></li>
                                </ul>
                            </div>
                            <div className="col-sm" id="footer-col-sm">
                                <h4>Social platforms</h4>
                                <li><a>You can also find me on these social media platforms</a></li>
                                <ul className="list-unstyled" id="list-one">
                                    <li id="icons1"><a href="https://www.linkedin.com/in/faith-muchembi-71b53910b" target="_blank"><span className="fa fa-linkedin" id="the-fa"></span></a></li>
                                    <li id="icons2"><a href="https://github.com/fmuchembi" target="_blank"><span className="fa fa-github" id="the-fa1" ></span></a></li>
                                    <li id="icons3"><a href="https://web.facebook.com/fmuchembi" target="_blank"><span className="fa fa-facebook" id="the-fa2"></span></a></li>
                                    <li id="icons5"><a href="https://twitter.com/muchembif" target="_blank"><span className="fa fa-twitter" id="the-fa4"></span></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="footer-section-2">
                <div className='footer-row2'>
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <p>Copyright &copy; <script>document.write(new Date().getFullYear());</script> Designed and built by Faith Muchembi</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>                                                            
    );
}

export default Home;